export const POST_CREATE_TENANT_REQUEST = 'POST_CREATE_TENANT_REQUEST';
export const POST_CREATE_TENANT_ERROR = 'POST_CREATE_TENANT_ERROR';
export const POST_CREATE_TENANT_SUCCESS = 'POST_CREATE_TENANT_SUCCESS';
